import { PrintSettingsInput } from '@e-socna/data-layer';
import type { Id } from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';

interface PrintSettings {
  readonly addHeaders: boolean;
  readonly addFooters: boolean;
  readonly printStyleId: Id;
}

export function printSettingsForm2ApiMapper(
  printSettings: Readonly<PrintSettings>,
) {
  return pruneInput(printSettings, PrintSettingsInput);
}
